export const SERVICES = [
  { key: "peinture", label: "Peinture façade", price: 50 },
  { key: "sous_couche_trame", label: "Sous-couche + trame", price: 35 },
  { key: "enduit", label: "Enduit projeté", price: 65 },
  { key: "ravalement", label: "Ravalement complet (sous-couche + trame + finition)", price: 100 },
  { key: "rejointoiement", label: "Rejointoiement briques", price: 180 },
  { key: "imitation_pierre", label: "Imitation pierre", price: 90 },
  { key: "imitation_brique", label: "Imitation brique", price: 100 },
  { key: "ite", label: "Isolation thermique extérieure", price: 200, from: true },
  { key: "hydrofuge", label: "Hydrofuge", price: 6 },
  { key: "demoussage_toiture", label: "Démoussage toiture", price: 18 },
];

export const SUPPORT_CONDITIONS = [
  { key: "good", label: "Bon état", multiplier: 1.0 },
  { key: "old_crepi_peeling", label: "Ancien crépi se décolle", multiplier: 1.2 },
];

export const ENDUITS = [
  { key: "blanc_casse", label: "Blanc cassé", color: "#F2EDE3" },
  { key: "ton_pierre", label: "Ton pierre", color: "#D9C9A8" },
  { key: "gris_clair", label: "Gris clair", color: "#C8C7C2" },
  { key: "gris_moyen", label: "Gris moyen", color: "#8C8B86" },
  { key: "anthracite", label: "Anthracite", color: "#3A3A3A" },
];

export const DECORATIVE_OPTIONS = [
  "Contours fenêtres imitation pierre",
  "Bandeaux verticaux imitation pierre",
  "Bandeaux verticaux blancs",
  "Pierre bleue sur appuis de fenêtres",
  "Pierre bleue décorative",
  "Soubassement noir",
  "Soubassement ton pierre",
  "Imitation brique rouge",
  "Imitation brique vieillie",
  "Encadrements modernes anthracite",
];

export const LIGHTING_OPTIONS = [
  "Éclairage LED façade blanc chaud",
  "Éclairage LED façade moderne",
  "Éclairage sol vers façade",
  "Mise en lumière des contours fenêtres",
  "Éclairage architectural haut de gamme",
];

export const RENOVATION_OPTIONS = [
  "Nettoyage toiture",
  "Hydrofuge façade",
  "Réfection appuis fenêtres",
  "Réparation fissures",
  "Sous-couche armée avec trame fibre",
];

export const CUSTOM_OPTIONS = [
  "Four à pizza extérieur en pierre",
  "Barbecue maçonné sur mesure",
  "Applique murale LED architecturale",
  "Sculpture / décoration murale en pierre",
  "Colonnes & bandeaux imitation pierre",
  "Margelle & habillage bassin / piscine",
  "Cheminée extérieure en pierre reconstituée",
  "Plan de travail extérieur pierre reconstituée",
];

// Real GMC project photos (user uploaded)
export const GMC_REALISATIONS = [
  {
    title: "Cube Moderne Brique & Anthracite",
    description: "Façade contemporaine : brique de récupération + bardage anthracite + toit cantilever",
    image:
      "https://customer-assets.emergentagent.com/job_facade-visualizer/artifacts/2dgzqu4s_IMG_5894.jpeg",
  },
  {
    title: "Pilier Brique Anthracite & Enduit",
    description: "Pilier de portail en brique anthracite + enduit clair + plaque numéro 695",
    image:
      "https://customer-assets.emergentagent.com/job_8aecca5a-5e7a-4dd2-b5b3-69c26a83e616/artifacts/o5idguvn_IMG_5883.jpeg",
  },
  {
    title: "Bassin Lagon en Pierre Reconstituée",
    description: "Aménagement extérieur : bassin lagon, pierre reconstituée et palmiers nains",
    image:
      "https://customer-assets.emergentagent.com/job_8aecca5a-5e7a-4dd2-b5b3-69c26a83e616/artifacts/8wz8t2b5_439BBA6D-9B12-4570-80AB-034E75022C6C.png",
  },
  {
    title: "Façade Brique Rouge & Crépi Beige",
    description: "Maison de ville : brique rouge ancienne + enduit beige + porte blanche cintrée",
    image:
      "https://customer-assets.emergentagent.com/job_8aecca5a-5e7a-4dd2-b5b3-69c26a83e616/artifacts/4u4a0i4g_IMG_5892.jpeg",
  },
  {
    title: "Mur Pierre Reconstituée Éclairé LED",
    description: "Mur en pierre reconstituée mis en lumière par appliques LED — vue nocturne",
    image:
      "https://customer-assets.emergentagent.com/job_8aecca5a-5e7a-4dd2-b5b3-69c26a83e616/artifacts/9kun4akd_IMG_5889.jpeg",
  },
  {
    title: "Maison Moderne Crépi Blanc",
    description: "Construction neuve : crépi blanc + pignon + soubassement brique grise + toit anthracite",
    image:
      "https://customer-assets.emergentagent.com/job_8aecca5a-5e7a-4dd2-b5b3-69c26a83e616/artifacts/sev9nn2j_IMG_5863.jpeg",
  },
  {
    title: "Applique Lune LED Architecturale",
    description: "Sculpture murale lumineuse — décoration extérieure haut de gamme",
    image:
      "https://customer-assets.emergentagent.com/job_facade-visualizer/artifacts/c9pdprch_IMG_5908.jpeg",
  },
  {
    title: "Maison Neuve Ton Pierre - Chantier",
    description: "Pose d'enduit projeté ton pierre sur construction neuve avec velux",
    image:
      "https://customer-assets.emergentagent.com/job_facade-visualizer/artifacts/20abewft_IMG_5906.jpeg",
  },
  {
    title: "Détail Façade & Cheminée Inox",
    description: "Enduit projeté ton pierre + colonne imitation pierre + cheminée inox double paroi",
    image:
      "https://customer-assets.emergentagent.com/job_facade-visualizer/artifacts/ard10pxk_IMG_5905.jpeg",
  },
  {
    title: "Four à Pizza Extérieur Pierre Reconstituée",
    description: "Réalisation sur mesure : four à pizza et barbecue en pierre reconstituée",
    image:
      "https://customer-assets.emergentagent.com/job_facade-visualizer/artifacts/5ko3rp1x_IMG_5907.jpeg",
  },
  {
    title: "Construction Neuve Crépi Beige",
    description: "Maison contemporaine : crépi beige + menuiseries noires Zilten — fin de chantier",
    image:
      "https://customer-assets.emergentagent.com/job_facade-visualizer/artifacts/e8g29a0e_IMG_4668.jpeg",
  },
  {
    title: "Façade Imitation Pierre de Taille",
    description: "Enduit décoratif imitation pierre de taille + fenêtres cintrées + porte moderne",
    image:
      "https://customer-assets.emergentagent.com/job_facade-visualizer/artifacts/e9rwv1on_IMG_5266.jpeg",
  },
  {
    title: "Enduit Beige & Appui Brique",
    description: "Détail façade : crépi beige texturé + appui de fenêtre en brique rouge ancienne",
    image:
      "https://customer-assets.emergentagent.com/job_facade-visualizer/artifacts/efebphxo_IMG_5113.jpeg",
  },
  {
    title: "Maison Neuve Crépi Beige",
    description: "Construction neuve : crépi beige + toit anthracite + appuis brique rouge",
    image:
      "https://customer-assets.emergentagent.com/job_facade-visualizer/artifacts/1t0qq7oj_IMG_5111.jpeg",
  },
  {
    title: "Siège & Flotte GMC Rénovation Façade",
    description: "Notre siège social et notre flotte de 4 véhicules pour intervenir rapidement dans tout le Nord",
    image:
      "https://customer-assets.emergentagent.com/job_facade-visualizer/artifacts/d4x33bkf_5BFCF792-6700-4750-AECB-8342A232340D.png",
  },
  {
    title: "Extension Crépi Crème & Terrasse Bois",
    description: "Extension moderne : crépi crème + menuiseries noires + carrelage effet bois",
    image:
      "https://customer-assets.emergentagent.com/job_facade-visualizer/artifacts/cz7igw3v_IMG_5551.jpeg",
  },
  {
    title: "Façade Brique Rouge & Crépi Terracotta",
    description: "Brique rouge conservée + enduit terracotta + grandes baies vitrées noires",
    image:
      "https://customer-assets.emergentagent.com/job_facade-visualizer/artifacts/siv4xtlv_IMG_5633.jpeg",
  },
  {
    title: "Façade Anthracite & Brique Sombre",
    description: "Enduit anthracite texturé + soubassement brique anthracite + volets roulants noirs",
    image:
      "https://customer-assets.emergentagent.com/job_facade-visualizer/artifacts/5iz8g2e1_IMG_5886.jpeg",
  },
  {
    title: "Façade Jaune Pastel & Soubassement Brique",
    description: "Enduit jaune pastel + soubassement brique rouge + toiture tuiles rouges",
    image:
      "https://customer-assets.emergentagent.com/job_facade-visualizer/artifacts/ng7bef8p_IMG_5891.jpeg",
  },
];

export const BEFORE_AFTER = [
  {
    title: "Maison ancienne - Anzin",
    before:
      "https://images.unsplash.com/photo-1610429576656-0f0278e98a2e?auto=format&fit=crop&w=1200&q=70&fm=webp",
    after:
      "https://customer-assets.emergentagent.com/job_8aecca5a-5e7a-4dd2-b5b3-69c26a83e616/artifacts/8wz8t2b5_439BBA6D-9B12-4570-80AB-034E75022C6C.png",
  },
  {
    title: "Façade brique - Saint-Saulve",
    before:
      "https://images.unsplash.com/photo-1568605114967-8130f3a36994?auto=format&fit=crop&w=1200&q=70&fm=webp",
    after:
      "https://customer-assets.emergentagent.com/job_8aecca5a-5e7a-4dd2-b5b3-69c26a83e616/artifacts/o5idguvn_IMG_5883.jpeg",
  },
  {
    title: "Mur extérieur - Marly",
    before:
      "https://images.unsplash.com/photo-1564013799919-ab600027ffc6?auto=format&fit=crop&w=1200&q=70&fm=webp",
    after:
      "https://customer-assets.emergentagent.com/job_8aecca5a-5e7a-4dd2-b5b3-69c26a83e616/artifacts/4u4a0i4g_IMG_5892.jpeg",
  },
];

export const TESTIMONIALS = [
  {
    name: "Sophie L.",
    city: "Valenciennes",
    rating: 5,
    text: "Travail d'orfèvre sur notre façade en brique. L'équipe GMC a transformé notre maison de 1930, le résultat dépasse nos attentes.",
  },
  {
    name: "Jean-Marc D.",
    city: "Anzin",
    rating: 5,
    text: "Devis clair, intervention dans les délais, finitions impeccables. Je recommande sans hésiter pour tout ravalement de façade.",
  },
  {
    name: "Catherine M.",
    city: "Marly",
    rating: 5,
    text: "Très professionnels du premier rendez-vous jusqu'au nettoyage final. Notre crépi imitation pierre est magnifique.",
  },
  {
    name: "Patrick B.",
    city: "Saint-Saulve",
    rating: 5,
    text: "Le configurateur en ligne nous a permis de visualiser le rendu avant de signer. Brillant, et exécution parfaite.",
  },
  {
    name: "Émilie R.",
    city: "Denain",
    rating: 5,
    text: "Façade isolée par l'extérieur + enduit ton pierre : notre maison a pris 20 ans de jeunesse et nous économisons sur le chauffage.",
  },
];

export const HERO_VIDEO =
  "https://videos.pexels.com/video-files/5779063/5779063-uhd_2560_1440_25fps.mp4";

export const HERO_FALLBACK =
  "https://customer-assets.emergentagent.com/job_8aecca5a-5e7a-4dd2-b5b3-69c26a83e616/artifacts/8wz8t2b5_439BBA6D-9B12-4570-80AB-034E75022C6C.png";

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_facade-visualizer/artifacts/6x9hi5nf_FD3F2181-23DE-485C-B987-D008535BB49F.png";
